import * as Settings from "../../settings";
const KEY = Settings.projectName + "Pagestate";
import { useAppStore } from "@/Store/AppStore";

// 保存页面当前状态
export function setPagestate(_key, _value) {
  const _pageState = JSON.parse(window.localStorage.getItem(KEY)) || {};
  _pageState[_key] = _value;
  window.localStorage.setItem(KEY, JSON.stringify(_pageState));
  const appStore = useAppStore();
  appStore.changePageState(_pageState);
}
// 获取页面当前状态
export function getPagestate() {
  const _pageState = JSON.parse(window.localStorage.getItem(KEY)) || {};
  const appStore = useAppStore();
  appStore.changePageState(_pageState);
  return _pageState;
}
